import { createIcon } from '@chakra-ui/icons';

export const Design1 = createIcon({
  displayName: 'Design1',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_916_24037)">
        <path
          d="M1.65 4.2L4.2 1.65L2.775 0.225C2.475 -0.075 2.025 -0.075 1.725 0.225L0.225 1.725C-0.075 2.025 -0.075 2.475 0.225 2.775L1.65 4.2Z"
          fill="currentColor"
        />
        <path
          d="M10.3488 7.80029L7.79883 10.3503L9.22383 11.7753C9.37383 11.9253 9.52383 12.0003 9.74883 12.0003H11.9988V9.75029C11.9988 9.52529 11.9238 9.37529 11.7738 9.22529L10.3488 7.80029Z"
          fill="currentColor"
        />
        <path
          d="M11.775 3.225L8.775 0.225C8.475 -0.075 8.025 -0.075 7.725 0.225L6.75 1.2L8.025 2.475L6.975 3.525L5.7 2.25L4.5 3.45L5.775 4.725L4.725 5.775L3.45 4.5L2.25 5.7L3.525 6.975L2.475 8.025L1.2 6.75L0.225 7.725C-0.075 8.025 -0.075 8.475 0.225 8.775L3.225 11.775C3.525 12.075 3.975 12.075 4.275 11.775L11.775 4.275C12.075 3.975 12.075 3.525 11.775 3.225Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_916_24037">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
